var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgActiveLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 47,
    viewBox: "0 0 47 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 23.5,
    cy: 23.5,
    r: 23.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30058_12116)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 24.75C25.6569 24.75 27 23.4069 27 21.75C27 20.0931 25.6569 18.75 24 18.75C22.3431 18.75 21 20.0931 21 21.75C21 23.4069 22.3431 24.75 24 24.75Z",
    stroke: "#0F5EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5 21.75C31.5 28.5 24 33.75 24 33.75C24 33.75 16.5 28.5 16.5 21.75C16.5 19.7609 17.2902 17.8532 18.6967 16.4467C20.1032 15.0402 22.0109 14.25 24 14.25C25.9891 14.25 27.8968 15.0402 29.3033 16.4467C30.7098 17.8532 31.5 19.7609 31.5 21.75Z",
    stroke: "#0F5EFF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30058_12116"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgActiveLocation);
export default __webpack_public_path__ + "static/media/activeLocation.9cf23709a58b67807edb370b730c1894.svg";
export { ForwardRef as ReactComponent };